// extracted by mini-css-extract-plugin
export default {"tabsWrap":"Reports_tabsWrap__SWOCE","modulesWrap":"Reports_modulesWrap__v1Rt0","queryInput":"Reports_queryInput__R2SPy","filterInput":"Reports_filterInput__wEeNp"};